import IconAirDresser from './assets/images/Air_dresser_line.svg'
import IconAirConditioner from './assets/images/AirConditioner.png'
import IconAirPurifier from './assets/images/AirPurifier.png'
import IconAV from './assets/images/AV.png'
import Iconbuds from './assets/images/buds.png'
import IconCamera from './assets/images/Camera_line.svg'
import Iconcooktop from './assets/images/cooktop.png'
import DarkIconAirDresser from './assets/images/dark/Air_dresser_line.svg'
import DarkIconCamera from './assets/images/dark/Camera_line.svg'
import DarkIconDishWasher from './assets/images/dark/Dish_washer_line.svg'
import DarkIconDryer from './assets/images/dark/Dryer_line.svg'
import DarkIconGeneralDevice from './assets/images/dark/General_device_line.svg'
import DarkIconGeneralDisplay from './assets/images/dark/General_display_line.svg'
import DarkIconIoT from './assets/images/dark/IoT_line.svg'
import DarkIconKimchiRefrigerator from './assets/images/dark/Kimchi_Refrigerator_line.svg'
import DarkIconLaptop from './assets/images/dark/Laptop_line.svg'
import DarkIconPc from './assets/images/dark/PC_line.svg'
import DarkIconPhone from './assets/images/dark/Phone_line.svg'
import DarkIconRefrigerator from './assets/images/dark/Refrigerator_line.svg'
import DarkIconRobotVacuum_1 from './assets/images/dark/Robot_vacuum1_line.svg'
import DarkIconAirConditioner from './assets/images/dark/Room_Air_Conditioner_line.svg'
import DarkIconSystem_AirConditioner from './assets/images/dark/System_Air_Conditioner_line.svg'
import DarkIconTablet from './assets/images/dark/Tablet_line.svg'
import DarkIconTv from './assets/images/dark/TV_line.svg'
import DarkIconWasher from './assets/images/dark/Washer_line.svg'
import DarkIconWatch from './assets/images/dark/Watch_line.svg'
import IconDishWasher from './assets/images/Dish_washer_line.svg'
import IconDryer from './assets/images/Dryer_line.svg'
import IconGeneralDevice from './assets/images/General_device_line.svg'
import IconGeneralDisplay from './assets/images/General_display_line.svg'
import Iconheadphone from './assets/images/headphone.png'
import Iconhood from './assets/images/hood.png'
import IconHumidifier from './assets/images/Humidifier.png'
import IconIoT from './assets/images/IoT_line.svg'
import Iconkimchi_refrigerator from './assets/images/Kimchi_Refrigerator_line.svg'
import IconLaptop from './assets/images/Laptop_line.svg'
import IconMicrowaveOven from './assets/images/MicrowaveOven.png'
import IconMobile from './assets/images/mobile.png'
import IconMobileAccessory from './assets/images/MobileAccessory.png'
import IconOven from './assets/images/Oven.png'
import IconPc from './assets/images/PC_line.svg'
import IconPhone from './assets/images/Phone_line.svg'
import IconPremiere from './assets/images/Premiere.png'
import IconQooker from './assets/images/Qooker.png'
import Iconrange from './assets/images/range.png'
import IconRefrigerator_LCD from './assets/images/Refrigerator_(LCD)_line.svg'
import IconRefrigerator from './assets/images/Refrigerator_line.svg'
import IconRobotVacuum_1 from './assets/images/Robot_vacuum1_line.svg'
import IconShoedresser from './assets/images/Shoedresser.png'
import Iconsignage from './assets/images/signage.png'
import IconSystem_AirConditioner from './assets/images/System_Air_Conditioner_line.svg'
import IconTablet from './assets/images/Tablet_line.svg'
import IconTv from './assets/images/TV_line.svg'
import IconTvAccessory from './assets/images/TvAccessory.png'
import IconWasher from './assets/images/Washer_line.svg'
import IconWatch from './assets/images/Watch_line.svg'
import IconWaterpurifier from './assets/images/Waterpurifier.png'

// import DarkIconRefrigerator_LCD from './assets/images/dark/Refrigerator_(LCD)_line.svg'

export const DeviceMap = {
  'PHONE DEVICE': { icon: IconPhone, darkIcon: DarkIconPhone, title: 'myinfo.device.phone.text' },
  CAMERA: { icon: IconCamera, darkIcon: DarkIconCamera, title: 'myinfo.device.camera.text' },
  TV: { icon: IconTv, darkIcon: DarkIconTv, title: 'myinfo.device.tv.text' },
  PC: { icon: IconPc, darkIcon: DarkIconPc, title: 'myinfo.device.pc.text' },
  AIRCONDITIONER: { icon: IconAirConditioner, darkIcon: DarkIconAirConditioner, title: 'myinfo.device.airconditioner.text' },
  WEARABLE: { icon: IconWatch, darkIcon: DarkIconWatch, title: 'myinfo.device.wearable.text' },
  IOTDEVICE: { icon: IconIoT, darkIcon: DarkIconIoT, title: 'myinfo.device.iotdevice.text' },
  IOT: { icon: IconIoT, darkIcon: DarkIconIoT, title: 'myinfo.device.iotdevice.text' },
  FAMILYHUB: { icon: IconRefrigerator_LCD, title: 'myinfo.device.familyhub.text' },
  'SMART WATCH': { icon: IconWatch, darkIcon: DarkIconWatch, title: 'myinfo.device.wearable.text' },
  ROBOTCLEANER: { icon: IconRobotVacuum_1, darkIcon: DarkIconRobotVacuum_1, title: 'myinfo.device.vacuumcleaner.text' },
  OVEN: { icon: IconOven, title: 'myinfo.device.oven.text' },

  // sandcrawler old version
  ACP: { icon: IconAirPurifier, title: 'myinfo.device.airpurifier.text' },
  AC: { icon: IconAirConditioner, darkIcon: DarkIconAirConditioner, title: 'myinfo.device.airconditioner.text' },
  AV: { icon: IconAV, title: 'myinfo.device.audio.text' },
  Oven: { icon: IconOven, title: 'myinfo.device.oven.text' },
  DW: { icon: IconDishWasher, darkIcon: DarkIconDishWasher, title: 'myinfo.device.dishwasher.text' },
  MWO: { icon: IconMicrowaveOven, title: 'myinfo.device.microwave.text' },
  'M-ACC': { icon: IconMobileAccessory, title: 'myinfo.device.etc.text' },
  MONITOR: { icon: IconGeneralDisplay, darkIcon: DarkIconGeneralDisplay, title: 'myinfo.device.monitor.text' },
  LAPTOP: { icon: IconLaptop, darkIcon: DarkIconLaptop, title: 'myinfo.device.pc.text' },
  DESKTOP: { icon: IconPc, darkIcon: DarkIconPc, title: 'myinfo.device.pc.text' },
  REF: { icon: IconRefrigerator, darkIcon: DarkIconRefrigerator, title: 'myinfo.device.refrigerator.text' },
  PHONE: { icon: IconPhone, darkIcon: DarkIconPhone, title: 'myinfo.device.phone.text' },
  'TV-ACC': { icon: IconTvAccessory, title: 'myinfo.device.etc.text' },
  TABLET: { icon: IconTablet, darkIcon: DarkIconTablet, title: 'myinfo.device.tablet.text' },
  VC: { icon: IconRobotVacuum_1, darkIcon: DarkIconRobotVacuum_1, title: 'myinfo.device.vacuumcleaner.text' },
  WM: { icon: IconWasher, darkIcon: DarkIconWasher, title: 'myinfo.device.washer.text' },
  WATCH: { icon: IconWatch, darkIcon: DarkIconWatch, title: 'myinfo.device.watch.text' },

  // sandcrawler new version
  'Air purifier': { icon: IconAirPurifier, title: 'myinfo.device.airpurifier.text' },
  Humidifier: { icon: IconHumidifier, title: '	myinfo.device.humidifier.text' },
  Dehumidifier: { icon: IconAirPurifier, title: 'myinfo.device.dehumidifier.text' },
  'Air conditioner': { icon: Iconheadphone, darkIcon: DarkIconAirConditioner, title: 'myinfo.device.headphones.text' },
  'Audio accessory': { icon: IconMobile, title: 'myinfo.device.phone.text' },
  'Home audio device': { icon: IconAV, title: 'myinfo.device.audio.text' },
  Headphones: { icon: Iconbuds, title: 'myinfo.device.phone.text' },
  Earbuds: { icon: IconMobile, title: 'myinfo.device.earbuds.text' },
  Range: { icon: Iconrange, title: 'myinfo.device.range.text' },
  Hood: { icon: Iconhood, title: 'myinfo.device.hood.text' },
  Hob: { icon: Iconcooktop, title: 'myinfo.device.hob.text' },
  Dishwasher: { icon: IconDishWasher, darkIcon: DarkIconDishWasher, title: 'myinfo.device.dishwasher.text' },
  'LED signage': { icon: Iconsignage, title: 'myinfo.device.led.signage.text' },
  Microwave: { icon: IconMicrowaveOven, title: 'myinfo.device.microwave.text' },
  'Mobile accessory': { icon: IconMobileAccessory, title: 'myinfo.device.etc.text' },
  Monitor: { icon: IconGeneralDisplay, darkIcon: DarkIconGeneralDisplay, title: 'myinfo.device.monitor.text' },
  Computer: { icon: IconPc, darkIcon: DarkIconPc, title: 'myinfo.device.pc.text' },
  Projector: { icon: IconPremiere, title: 'myinfo.device.projector.text' },
  Refrigerator: { icon: IconRefrigerator, darkIcon: DarkIconRefrigerator, title: 'myinfo.device.refrigerator.text' },
  'SMART signage': { icon: Iconsignage, title: 'myinfo.device.smart.signage.text' },
  Phone: { icon: IconPhone, darkIcon: DarkIconPhone, title: 'myinfo.device.phone.text' },
  'System air conditioner': {
    icon: IconSystem_AirConditioner,
    darkIcon: DarkIconSystem_AirConditioner,
    title: 'myinfo.device.system.air.conditioner.text'
  },
  Tablet: { icon: IconTablet, darkIcon: DarkIconTablet, title: 'myinfo.device.tablet.text' },
  'Vacuum cleaner': { icon: IconRobotVacuum_1, darkIcon: DarkIconRobotVacuum_1, title: 'myinfo.device.vacuumcleaner.text' },
  Washer: { icon: IconWasher, darkIcon: DarkIconWasher, title: 'myinfo.device.washer.text' },
  Dryer: { icon: IconDryer, darkIcon: DarkIconDryer, title: 'myinfo.device.dryer.text' },
  AirDresser: { icon: IconAirDresser, darkIcon: DarkIconAirDresser, title: 'myinfo.device.air.dresser.text' },
  Watch: { icon: IconWatch, darkIcon: DarkIconWatch, title: 'myinfo.device.wearable.text' },
  'Kimchi refrigerator': {
    icon: Iconkimchi_refrigerator,
    darkIcon: DarkIconKimchiRefrigerator,
    title: 'myinfo.device.kimchi.refrigerator.text'
  },
  'Water purifier': { icon: IconWaterpurifier, title: 'myinfo.device.water.purifier.text' },
  'Shoe dresser': { icon: IconShoedresser, title: 'myinfo.device.shoe.dresser.text' },
  Qooker: { icon: IconQooker, title: 'myinfo.device.qooker.text' }
}

export const getDeviceIcon = (type, mode = 'light') => {
  const device = DeviceMap[type]

  if (!device) {
    return mode === 'dark' ? DarkIconGeneralDevice : IconGeneralDevice
  }

  if (mode === 'dark') {
    return device.darkIcon || device.icon || DarkIconGeneralDevice
  } else {
    return device.icon || IconGeneralDevice
  }
}
